const afterSubmitFail = (errors) => {

    var errorElemName = Object.keys(errors)[0];
    var fieldObj = document.querySelector('input.form-control[name="' + errorElemName + '"]');
    // element exists and is visible (it can be invisible on the CompanyForm tabs)
	if (fieldObj && (fieldObj.offsetParent !== null)) {
		fieldObj.focus();
        return;
	}

    fieldObj = document.getElementById('div_' + errorElemName);
    // element exists and is visible (it can be invisible on the CompanyForm tabs)
    if (fieldObj && (fieldObj.offsetParent !== null)) {
        fieldObj.scrollIntoView();
        return;
    }
    // for CompanyForm case
    var activeTab = document.querySelector('a.nav-link.tab-with-errors');
    if (activeTab) {
        activeTab.scrollIntoView();
    }
};

export default afterSubmitFail;


// WEBPACK FOOTER //
// ./web/src/components/common/form/focusAfterSubmitFail.js